module.exports = __webpack_public_path__ + "static/img/logo.c5025463.png";